import { render, staticRenderFns } from "./LuckyGridPage.vue?vue&type=template&id=0c9c284f&scoped=true"
import script from "./LuckyGridPage.vue?vue&type=script&lang=js"
export * from "./LuckyGridPage.vue?vue&type=script&lang=js"
import style0 from "./LuckyGridPage.vue?vue&type=style&index=0&id=0c9c284f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c284f",
  null
  
)

export default component.exports